import AGREGAR_OBRA from '@/graphql/mutations/administracion/planeacion/agregarObra.gql';
import OBRAS from '@/graphql/querys/administracion/planeacion/buscarObras.gql';
import ACTUALIZAR_OBRA from '@/graphql/mutations/administracion/planeacion/actualizarObra.gql';
import REMOVER_OBRA from '@/graphql/mutations/administracion/planeacion/removerObra.gql';
import TIPOS_OBRAS from '@/graphql/querys/administracion/catalogos/tiposobras/tiposObras.gql';
import SUB_TIPOS_OBRAS from '@/graphql/querys/administracion/catalogos/subtiposobras/subTiposObras.gql';
import MUNICIPIOS from '@/graphql/querys/administracion/catalogos/municipios/municipios.gql';
import PROGRAMAS_INVERSIONES from '@/graphql/querys/administracion/catalogos/programasinversiones/programasInversiones.gql';
import AGREGAR_ETIQUETA_OBRA from '@/graphql/mutations/administracion/etiquetas/agregarEtiquetas.gql';
import REMOVER_ETIQUETA_OBRA from '@/graphql/mutations/administracion/etiquetas/removerEtiqueta.gql';

export default {
  apollo: {
    tiposObras: {
      query: TIPOS_OBRAS,
    },
    subTiposObras: {
      query: SUB_TIPOS_OBRAS,
    },
    municipios: {
      query: MUNICIPIOS,
    },
    programasInversiones: {
      query: PROGRAMAS_INVERSIONES,
    },
  },
  methods: {
    mixGuardarBasico() {
      return this.$apollo.mutate({
        mutation: AGREGAR_OBRA,
        variables: {
          obra: this.obra,
        },
      })
        .then((resultado) => resultado)
        .catch((err) => ({ err }));
    },
    async mixAgregarObra() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: AGREGAR_OBRA,
        variables: {
          obra: this.obra,
        },
        update: (store, { data: { agregarObra } }) => {
          const query = {
            query: OBRAS,
            variables: {
              filtros: {
                ejercicio: this.filtros.ejercicio,
                buscar: this.filtros.buscar,
                idTipo: this.filtros.idTipo,
                idPrograma: this.filtros.idPrograma,
                etiquetas: this.filtros.etiquetas,
                incluirConContratos: this.filtros.incluirConContratos,
                numeroRegistros: this.filtros.numeroRegistros,
                pagina: this.filtros.pagina,
              },
            },
          };
          const data = store.readQuery(query);
          const { buscarObras } = data;
          buscarObras.obras.push(agregarObra);
          store.writeQuery({ ...query, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },

    async mixActualizarObra() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: ACTUALIZAR_OBRA,
        variables: {
          id: this.obraEditar.id,
          obra: this.obra,
        },
        update: (store, { data: { actualizarObra } }) => {
          const query = {
            query: OBRAS,
            variables: {
              filtros: {
                ejercicio: this.filtros.ejercicio,
                buscar: this.filtros.buscar,
                idTipo: this.filtros.idTipo,
                idPrograma: this.filtros.idPrograma,
                etiquetas: this.filtros.etiquetas,
                incluirConContratos: this.filtros.incluirConContratos,
                numeroRegistros: this.filtros.numeroRegistros,
                pagina: this.filtros.pagina,
              },
            },
          };
          const data = store.readQuery(query);
          const { buscarObras } = data;
          const { obras } = buscarObras;
          const index = obras
            .findIndex((obra) => obra.id === actualizarObra.id);
          if (index !== -1) {
            obras.splice(index, 1, actualizarObra);
          }
          store.writeQuery({ ...query, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },

    async mixEliminarObra() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: REMOVER_OBRA,
        variables: {
          id: this.obraEliminar.id,
        },
        update: (store) => {
          const query = {
            query: OBRAS,
            variables: {
              filtros: {
                ejercicio: this.filtros.ejercicio,
                buscar: this.filtros.buscar,
                idTipo: this.filtros.idTipo,
                idPrograma: this.filtros.idPrograma,
                etiquetas: this.filtros.etiquetas,
                incluirConContratos: this.filtros.incluirConContratos,
                numeroRegistros: this.filtros.numeroRegistros,
                pagina: this.filtros.pagina,
              },
            },
          };
          const data = store.readQuery(query);
          const { buscarObras } = data;
          const index = buscarObras.obras
            .findIndex((obra) => obra.id === this.obraEliminar.id);
          if (index !== -1) {
            buscarObras.obras.splice(index, 1);
          }
          store.writeQuery({ ...query, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
    mixAgregarEtiquetaObra(idObra, etiquetas) {
      return this.$apollo.mutate({
        mutation: AGREGAR_ETIQUETA_OBRA,
        variables: {
          idReferencia: idObra,
          etiquetas,
        },
        update: (store, { data: { agregarEtiquetas } }) => {
          const query = {
            query: OBRAS,
            variables: {
              filtros: {
                ejercicio: this.filtros.ejercicio,
                buscar: this.filtros.buscar,
                idTipo: this.filtros.idTipo,
                idPrograma: this.filtros.idPrograma,
                etiquetas: this.filtros.etiquetas,
                incluirConContratos: this.filtros.incluirConContratos,
                numeroRegistros: this.filtros.numeroRegistros,
                pagina: this.filtros.pagina,
              },
            },
          };
          const data = store.readQuery(query);
          const { buscarObras } = data;
          const { obras } = buscarObras;
          const findedObra = obras.find((obra) => obra.id === idObra);
          if (findedObra && agregarEtiquetas) {
            findedObra.etiquetas.push(...agregarEtiquetas);
          }
          store.writeQuery({ ...query, data });
        },
      })
        .then((resultado) => resultado)
        .catch((err) => ({ err }));
    },
    mixRemoverEtiquetaDeObra(id, idObra) {
      return this.$apollo.mutate({
        mutation: REMOVER_ETIQUETA_OBRA,
        variables: {
          id,
        },
        update: (store) => {
          const query = {
            query: OBRAS,
            variables: {
              filtros: {
                ejercicio: this.filtros.ejercicio,
                buscar: this.filtros.buscar,
                idTipo: this.filtros.idTipo,
                idPrograma: this.filtros.idPrograma,
                etiquetas: this.filtros.etiquetas,
                incluirConContratos: this.filtros.incluirConContratos,
                numeroRegistros: this.filtros.numeroRegistros,
                pagina: this.filtros.pagina,
              },
            },
          };
          const data = store.readQuery(query);
          const { buscarObras } = data;
          const { obras } = buscarObras;
          const findedObra = obras.find((obra) => obra.id === idObra);
          if (findedObra) {
            const index = findedObra.etiquetas
              .findIndex((etiquetaRelacion) => etiquetaRelacion.id === id);
            if (index !== -1) {
              findedObra.etiquetas.splice(index, 1);
            }
          }
          store.writeQuery({ ...query, data });
        },
      })
        .then((resultado) => resultado)
        .catch((err) => ({ err }));
    },
  },
  computed: {
    getSubTipoObraPorTipo() {
      if (!this.subTiposObras || this.obra.idTipo === '') return [];
      return this.subTiposObras
        .filter(({ idTipo }) => idTipo === this.obra.idTipo);
    },
  },
};
